module.exports = __webpack_public_path__ + "static/media/emoha-new-logo.2a11aac4.png";